import React from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer bg-dark text-white py-5">
      <div className="container">
        <div className="row">
          {/* Column 1: Logo and Social Icons */}
          <div className="col-md-3 footerCols">
            <img
              src="/resizedlogo.png"
              alt="Company Logo"
              className="footer-logo mb-3"
            />
            <p className="text-white justify-left">
              At Printingy, we are committed to delivering top-tier printing
              solutions tailored to your unique needs. With expertise across
              industries like retail, education, hospitality, and corporate
              sectors.
            </p>
            {/* <div className="social-icons">
              <a href="#" className="text-white me-3">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="text-white me-3">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="text-white me-3">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="#" className="text-white">
                <i className="fab fa-instagram"></i>
              </a>
            </div> */}
          </div>

          {/* Column 2: Services */}
          <div className="col-md-3 footerCols">
            <h5>Services</h5>
            <ul className="list-unstyled">
              <li>
                {" "}
                <Link to="/custom-flyers-printing-services">
                  Custom Flyers Printing Services
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/certificate-printing-services">
                  Certificate Printing Services
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/business-card-printing">
                  Business Card Printing
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/school-copy-printing">
                  School Copy Printing
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/presentation-printing">
                  Presentation Printing
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/custom-pocket-folder">
                  Custom Pocket Folder
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/postcard-printing-and-designing">
                  Postcard Printing & Designing
                </Link>{" "}
              </li>
            </ul>
          </div>

          {/* Column 3: More Services */}
          <div className="col-md-3 footerCols">
            <br></br><br></br>
            <ul className="list-unstyled">
              <li>
                {" "}
                <Link to="/custom-envelops">Custom Envelops</Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/custom-notepads">Custom Notepads</Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/stamps-and-embossers">
                  Stamps and Embossers
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/document-printing-and-binding">
                  Document Printing & Binding
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/rack-card-design">Rack Card Design</Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/door-hanger-printing">
                  Door Hanger Printing
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/custom-note-cards">Custom Note Cards</Link>{" "}
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Information */}
          <div className="col-md-3 footerCols">
            <h5>Contact Info</h5>
            <ul className="list-unstyled">
              <li>
                <a href="tel:+91-9990168777">
                  <i className="fas fa-phone me-2"></i>9990168777
                </a>
              </li>
              <li>
                <a href="mailto:wow@printingy.com">
                  <i className="fas fa-envelope me-2"></i>wow@printingy.com
                </a>
              </li>
              <li>
                
                  <i className="fas fa-map-marker-alt me-2"></i>301 C, 3rd Floor, Supermart 2, DLF Phase 4, <br></br>Gurugram, Haryana, 122009
               
              </li>
              <br></br>
              <li>
              Registered Firm - Enlargenet <br></br>
GST - 06ADIPB5368H3ZJ <br></br>
MSME UDYAM-HR-05-0076774
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
